import { createContext } from 'react';

type ContextT = {
  searchValue: string;
  searchValueConversation: string;
};

export const SearchValueContext = createContext<ContextT>({ searchValue: '', searchValueConversation: '' });
